import { skip } from 'rxjs/operators';
import { BreakpointMinService } from 'src/app/@utils/breakpoint-min.service';

import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ProductDetailService } from '@features/product-detail/product-detail.service';
import { ActiveCampaign, ProductSplash } from '@features/product/product.models';
import { ProductSplashViewModel } from '@models/api-search.models';
import { SliderComponent } from '@features/slider/slider/slider.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GetCampaignSplashPipe } from '../../product/pipes/get-campaign-splash.pipe';
import { FirstSplashPipe } from '../../product/pipes/first-splash.pipe';
import { GetCampaignTypePipe } from '../../product/pipes/get-campaign-type.pipe';
import { CampaignByMemberTypePipe } from '../../product/pipes/campaign-by-member-type.pipe';
import { ColorStringToHexPipe } from '@shared/product-details-pipes/color-string-to-hex.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { ProductImageComponent } from '@shared/image/product-image/product-image.component';

import { ImageComponent } from '@shared/image/image/image.component';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { ProductSplashComponent } from '../../product/product-splash/product-splash.component';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';

import { VideoPlayerComponent } from '@features/video-player/video-player/video-player.component';
import { MultipleVideosPipe } from '@features/video-player/pipes/multiple-videos.pipe';

@UntilDestroy()
@Component({
    selector: 'app-product-slider',
    templateUrl: './product-slider.component.html',
    styleUrls: ['./product-slider.component.scss'],
    host: { ngSkipHydration: 'true' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    NgIf,
    ProductSplashComponent,
    NgClass,
    SvgIconComponent,
    SliderComponent,
    NgFor,
    ImageComponent,
    ProductImageComponent,
    AsyncPipe,
    TranslateSafePipe,
    ColorStringToHexPipe,
    CampaignByMemberTypePipe,
    GetCampaignTypePipe,
    FirstSplashPipe,
    GetCampaignSplashPipe,
    VideoPlayerComponent,
    MultipleVideosPipe
]
})
export class ProductSliderComponent {
    @ViewChild('slider')
    private slider: SliderComponent;

    @Input()
    public readonly campaignSplash?: ProductSplash;

    @Input()
    public readonly activeSplashes?: ProductSplashViewModel[];

    @Input()
    public readonly activeCampaigns?: ActiveCampaign[];

    constructor(
        public readonly productDetailService: ProductDetailService,
        public readonly breakpointServiceMin: BreakpointMinService
    ) {
        this.productDetailService.productDetail$.pipe(skip(1), untilDestroyed(this)).subscribe(() => {
            // Because we do not currently know when slider is done rendering, we place these functions at the back of queue.
            // TODO: Create a generic method in slider component, that does handles changes in slider content
            window.setTimeout(() => {
                this.slider.setPaging();
                this.slider.goToPage(0, 0);
            });
        });
    }
}
